/**
 * Header functionality including mobile menu and dropdowns
 */

function handleDropdownOpen(subMenu, toggle) {
    subMenu.classList.remove("hidden");
    const height = subMenu.scrollHeight + "px";
    subMenu.style.maxHeight = "0";
    requestAnimationFrame(() => {
        subMenu.style.maxHeight = height;
    });
    toggleIcon(toggle, "open");
    subMenu.addEventListener("transitionend", () => {
        subMenu.style.maxHeight = null;
    }, { once: true });
}

function handleDropdownClose(subMenu, toggle) {
    subMenu.style.maxHeight = subMenu.scrollHeight + "px";
    requestAnimationFrame(() => {
        subMenu.style.maxHeight = "0";
    });
    toggleIcon(toggle, "close");
    subMenu.addEventListener("transitionend", () => {
        subMenu.classList.add("hidden");
    }, { once: true });
}

function toggleIcon(toggle, action) {
    const icon = toggle.querySelector("svg");
    if (icon) {
        if (action === "open") {
            icon.innerHTML = '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>';
        } else {
            icon.innerHTML = '<polyline points="9 18 15 12 9 6"></polyline>';
        }
    }
}

export function initializeHeader() {
    // Mobile menu toggle
    const menuToggle = document.getElementById("menu-toggle");
    if (menuToggle) {
        menuToggle.addEventListener("click", function() {
            const nav = document.getElementById("header-mobile-nav");
            if (nav.classList.contains("hidden")) {
                nav.classList.remove("hidden");
                nav.classList.add("flex", "lg:hidden");
            } else {
                nav.classList.remove("flex", "lg:hidden");
                nav.classList.add("hidden");
            }
        });
    }

    // Desktop dropdowns
    const menuItems = document.querySelectorAll(".has-dropdown");
    menuItems.forEach(function(item) {
        item.addEventListener("mouseenter", function() {
            this.querySelector(".sub-menu")?.classList.remove("hidden");
        });

        item.addEventListener("mouseleave", function() {
            this.querySelector(".sub-menu")?.classList.add("hidden");
        });
    });

    // Mobile dropdowns
    const dropdownToggles = document.querySelectorAll(".dropdown-toggle");
    dropdownToggles.forEach((toggle) => {
        toggle.addEventListener("click", function(e) {
            e.preventDefault();
            const parentLi = this.closest("li");
            const subMenu = parentLi.nextElementSibling;

            if (subMenu?.classList.contains("sub-menu")) {
                if (subMenu.classList.contains("hidden")) {
                    handleDropdownOpen(subMenu, this);
                } else {
                    handleDropdownClose(subMenu, this);
                }
            }
        });
    });
}